import('./AppBootstrap')
  .then(async ({ renderApp }) => {
    await renderApp();
  })
  .catch(error => {
    // eslint-disable-next-line no-console
    console.error('Failed to bootstrap af_billing_inquiry', error);
  });

export {};
